import { getSessionData } from '../hooks/api';
import { usePsychologistData } from '../hooks/usePsychologistData';

/**
 * Nombre con el que se saluda a quien está logueada. Mismo criterio que el saludo de la Home de la web
 * (`psychologist.name`); mientras carga, o si falta, el de la sesión (que también viene vacío en una sesión
 * impersonada). Devuelve `undefined` si no hay ninguno.
 */
export function useGreetingName(): string | undefined {
  const psychologist = usePsychologistData();
  const name = (psychologist?.name || getSessionData()?.user?.name || '').trim();
  return name || undefined;
}
